/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: perfildocenteController
* # alias: perfildocenteVM
*/

export default class perfildocenteController {

  constructor($scope, $state, $stateParams, ngNotify, UserInfoConstant, perfilSrv, $cookies, $mdDialog, i18nService) {
    this.$scope = $scope;
    this.$state = $state;
    this.ngNotify = ngNotify;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.perfilSrv = perfilSrv;
    this.userinfo = null;
    this.$cookies = $cookies;
    this.$scope.gridOptionsComplex = {
      enableFiltering: true,
      showFooter: true,
      //rowHeight: 36,
      enableGridMenu: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      columnDefs: [
        { displayName: 'Nivel',field:'Level', width: '10%' },
        { displayName: 'Período',field:'Periodo', width: '15%' },
        { displayName: 'Asignatura',field:'Asignatura', width: '25%' },
        { displayName: 'Programa/Área',field:'ProgramaArea', width: '30%' },
        { displayName: 'Dedicación',field:'Dedic', width: '10%' },
        { displayName: 'Número de grupos',field:'cantGroup', width: '10%' },
        { displayName: 'Ver más',field:'Ver más', width: '10%', cellTemplate:require('./dialogbutton.html'), pinnedRight:true }
      ]
    }; 
    this.$scope.UserInfoConstant = UserInfoConstant;
    this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
      if (details !== undefined) {
        this.userinfo = details.user;
        this.userinfo.role_id = this.$cookies.get('hasRoleId');
        this.main();
      }
    });
    i18nService.setCurrentLang('es')
  }

  main() {
    /**
    * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
    **/
    if (this.$stateParams.teacherId != '') {
      this.userinfo.teacherId = this.$stateParams.teacherId;
      this.getperfildocente(this.userinfo.teacherId);
    } else {
      this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
        if (!response.status) {
          this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
        } else {
          this.role = response.data[0];
          if (this.role.types == 'TEACHER') {
            this.getInfo();
          } else {
            this.$state.go('profile.perfil_dash');
            this.ngNotify.set('No se ha especificado ningún docente', 'info');
          }
        }
      }, (err) => {
        this.ngNotify.set('Imposible conectar con el servicio', 'error');
      });
    }
  }

  goBack(){
    this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
}

  getInfo() {
    this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
      if (!response.status) {
        this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
      } else {
        this.userinfo.teacherId = response.data[0].idTeacher;
        this.getperfildocente(this.userinfo.teacherId);
      }
    }, (err) => {
      this.ngNotify.set('Imposible conectar con el servicio', 'error');
    });
  }

  getperfildocente(teacherId) {
    this.perfilSrv.perfildocente.getperfildocente({teacherId:teacherId}).$promise.then((response) => {
      if (response.status) {
        this.$scope.gridOptionsComplex.data = this.buildingTable(response.data);
      }
    }, (data) => {
      this.ngNotify.set('Imposible conectar con el servicio', 'error');
    });
  }

  buildingTable(data) {
    let result = [];
    let currentLevel = null;
    for (let i in data) {      
      if (currentLevel != data[i].Nivel) {
        currentLevel = data[i].Nivel;
        result.push({$$treeLevel: 0,'Level': data[i].Nivel});
      }
      result.push(data[i]);
    }
    return result;
  }

  returnBack () {
    window.history.back()
  }

  showModal (row) {
    let confirm = this.$mdDialog.confirm({
      controller   : 'dialogdetailcontroller',
      controllerAs : 'dialogdetaildocente',
      template     : require('./dialog/dialogdetail.html'),
      locals       : {data: {row: row, user: this.userinfo}},
      animation    : true,
      parent       : angular.element(document.body),
      clickOutsideToClose : true
    })

    this.$mdDialog.show(confirm);
  }

}

perfildocenteController.$inject = ['$scope',
                                    '$state',
                                    '$stateParams',
                                    'ngNotify',
                                    'UserInfoConstant',
                                    'perfilSrv',
                                    '$cookies',
                                    '$mdDialog',
                                    'i18nService'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_docente/perfildocenteController.js